import * as S from './Sticker.styles';
import { StickerSize } from './Sticker.styles';

type StickerProps = {
  children: any;
  color?: 'greenSecondary' | 'red';
  size?: StickerSize;
};

export function Sticker(props: StickerProps): React.ReactElement {
  const { children, color, size } = props;

  return (
    <S.Container color={color}>
      <S.Label
        fontFamily="LFT Zeno"
        textAlign="center"
        textTransform="uppercase"
        color="white"
        scale="s"
        $size={size}
      >
        {children}
      </S.Label>
    </S.Container>
  );
}
